import { retailerSettingsService } from '../services/retailer-settings/retailer-settings';

const product = retailerSettingsService.getProduct();
const customCssUrl = window.returnsSettings[product].css_src || '';
let customCssLoaded = false;

const createStylesheetLink = (href) => {
  const linkElement = document.createElement('link');
  linkElement.setAttribute('rel', 'stylesheet');
  linkElement.setAttribute('type', 'text/css');
  linkElement.setAttribute('href', href);
  return !href || customCssLoaded ? '' : linkElement;
};

export const loadCustomCss = () => {
  const customCssLink = createStylesheetLink(customCssUrl);

  if (customCssLink) {
    document.head.appendChild(customCssLink);
    customCssLoaded = true;
  }
};
